var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 58,
    viewBox: "0 0 64 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 60,
    height: 43.3979,
    rx: 5,
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0249 11C23.3838 11 18 16.3838 18 23.025C18 29.6662 23.3838 35.05 30.0249 35.05C32.7597 35.05 35.2812 34.1371 37.3014 32.5994L41.226 36.524C41.8606 37.1587 42.8895 37.1587 43.5241 36.524C44.1586 35.8894 44.1586 34.8606 43.5241 34.226L39.5994 30.3013C41.137 28.2811 42.0499 25.7597 42.0499 23.025C42.0499 16.3838 36.6661 11 30.0249 11ZM21.25 23.025C21.25 18.1787 25.1787 14.25 30.0249 14.25C34.8712 14.25 38.7999 18.1787 38.7999 23.025C38.7999 27.8713 34.8712 31.8 30.0249 31.8C25.1787 31.8 21.25 27.8713 21.25 23.025Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4906 56.5059C14.4906 55.9536 14.9383 55.5059 15.4906 55.5059H47.3019C47.8542 55.5059 48.3019 55.9536 48.3019 56.5059V58.0005H14.4906V56.5059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.149 49.9906C25.2731 49.5634 25.6645 49.2695 26.1093 49.2695H36.683C37.1279 49.2695 37.5193 49.5634 37.6433 49.9906L39.2452 55.5061H23.5471L25.149 49.9906Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23C21 27.9706 25.0294 32 30 32C34.9706 32 39 27.9706 39 23C39 18.0294 34.9706 14 30 14C25.0294 14 21 18.0294 21 23Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyseIcon);
export default __webpack_public_path__ + "static/media/analyseIcon.05b49b10c04df55ee035277181ad3d82.svg";
export { ForwardRef as ReactComponent };